import React from 'react'
import Pagination from 'react-js-pagination'

const Paginator = props => {
    const { activePage, itemsCountPerPage, totalItemsCount, onChange } = props
    const PER_PAGE = 5
    return (
        <Pagination
            hideDisabled
            activePage={activePage}
            itemsCountPerPage={itemsCountPerPage}
            totalItemsCount={totalItemsCount}
            pageRangeDisplayed={PER_PAGE}
            prevPageText={<i className="fa fa-angle-left" />}
            nextPageText={<i className="fa fa-angle-right" />}
            firstPageText={<i className="fa fa-angle-double-left" />}
            lastPageText={<i className="fa fa-angle-double-right" />}
            onChange={onChange}
        />
    )
}

export default Paginator


// WEBPACK FOOTER //
// ./src/acervo/components/UI/Paginator/Paginator.js